import React from 'react';
import { motion } from 'framer-motion';
import { 
  CalendarClock, 
  Building2, 
  Calendar, 
  Globe, 
  Rocket, 
  Briefcase, 
  ThumbsUp, 
  Users 
} from 'lucide-react';

const statsData = [
  { 
    id: 1, 
    value: "16+ Years", 
    label: "Years in Business", 
    icon: <CalendarClock size={24} /> 
  },
  { 
    id: 2, 
    value: "500+", 
    label: "Major Projects Completed", 
    icon: <Building2 size={24} /> 
  },
  { 
    id: 3, 
    value: "15+", 
    label: "Completed Initiatives", 
    icon: <Calendar size={24} /> 
  },
  { 
    id: 4, 
    value: "8+", 
    label: "Service Categories", 
    icon: <Globe size={24} /> 
  },
  { 
    id: 5, 
    value: "100% - 150%", 
    label: "Revenue Growth", 
    icon: <Rocket size={24} /> 
  },
  { 
    id: 6, 
    value: "6+ Companies", 
    label: "Portfolio", 
    icon: <Briefcase size={24} /> 
  },
  { 
    id: 7, 
    value: "100%", 
    label: "Client Satisfaction Rate", 
    icon: <ThumbsUp size={24} /> 
  },
  { 
    id: 8, 
    value: "50+", 
    label: "Employees", // "Employee Bee" ko "Employees" kar diya hai (typo fix)
    icon: <Users size={24} /> 
  },
];

const KeyStatistics = () => {
  // Container Animation (Stagger Effect)
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1, // Har card 0.1s ke gap ke baad aayega
      },
    },
  };

  const box = {
    borderRadius: '10px',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
  };

  // Card Animation (Spring Physics)
  const cardVariants = {
    hidden: { 
      opacity: 0, 
      y: 50, 
      scale: 0.9 
    },
    visible: { 
      opacity: 1, 
      y: 0, 
      scale: 1,
      transition: {
        type: "spring", 
        bounce: 0.4,    
        duration: 0.8
      }
    },
  };

  return (
    <section className="bg-gray-50 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Section */}
        <div className="text-center mb-16 space-y-4">
          <motion.h2 
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-semibold text-black"
          >
            Key Performance Indicators
          </motion.h2>
            <motion.div 
              initial={{ width: 0 }}
              whileInView={{ width: 250 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="h-1 bg-[#2a3890] mx-auto rounded-full"
            />
        </div>

        {/* Grid Section */}
        <motion.div 
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }} // Jab 20% dikhe tab animation start ho
        >
          {statsData.map((stat) => (
            <motion.div
              style={box}
              animate={{ rotate: 360 }}
              transition={{ duration: 1 }}
              key={stat.id}
              variants={cardVariants}
              whileHover={{ 
                scale: 1.05, 
                boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
                transition: { type: "spring", stiffness: 300 } 
              }}
              className="bg-white p-6 text-center shadow-sm border border-gray-100 cursor-pointer group hover:border-[#2a3890]/30 transition-colors"
            >
              {/* Icon Container - Centered */}
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-[#f0f4ff] rounded-full text-[#2a3890] group-hover:bg-[#2a3890] group-hover:text-white transition-colors duration-300">
                  {stat.icon}
                </div>
              </div>

              <h3 className="text-1xl md:text-2xl font-semibold text-[#0f172a] mb-2">
                {stat.value}
              </h3>
              <p className="text-gray-500 font-medium text-sm md:text-xs uppercase tracking-wider group-hover:text-[#2a3890] transition-colors">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default KeyStatistics;